<template>
    <div id="app">
        <transition name="fade">
            <router-view class="router-view"></router-view>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'app',
};
</script>

<style lang="scss">
    @import "../static/style/base.scss";
    @import "../static/style/animate.css";
    html, body, #app {
        min-height: 100vh;
        position: relative;
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s
    }
    .fade-enter, .fade-leave-active {
        opacity: 0
    }

    .fade1-enter-active, .fade1-leave-active {
        transition: opacity .1s
    }
    .fade1-enter, .fade1-leave-active {
        opacity: 0
    }
</style>



// WEBPACK FOOTER //
// src/App.vue